window.$ = require("jquery");

// https://flatpickr.js.org/
const flatpickr = require("flatpickr");

//https://datatables.net/
import DataTable from "datatables.net-bs5";
import "datatables.net-fixedcolumns-bs5";
import "datatables.net-fixedheader-bs5";
import "datatables.net-responsive-bs5";
import "datatables.net-rowreorder-bs5";

let dataTableLang = {
  lengthMenu: "_MENU_",
  emptyTable: "Search did not yield any results",
  info: "_TOTAL_ | _START_ - _END_",
  infoFiltered: "",
  infoEmpty: "Search result: 0",
}
const lang = document.querySelector("html").getAttribute("lang");
switch (lang) {
  case "az":
    flatpickr.default.localize(require("flatpickr/dist/l10n/az").default.az);
    dataTableLang = {
      lengthMenu: "_MENU_",
      emptyTable: "Axtarış heç bir nəticə vermədi",
      info: "_TOTAL_ | _START_ - _END_",
      infoFiltered: "",
      infoEmpty: "Axtarış nəticəsi: 0",
    }
    break;
  case "ru":
    flatpickr.default.localize(require("flatpickr/dist/l10n/ru").default.ru);
    dataTableLang = {
      lengthMenu: "_MENU_",
      emptyTable: "Поиск не дал результатов",
      info: "_TOTAL_ | _START_ - _END_",
      infoFiltered: "",
      infoEmpty: "Результат поиска: 0",
    }
    break;
}

let tableColumns = [];
let tableColumnsJson = $("#tableColumns");
if (tableColumnsJson.length > 0) {
  tableColumns = Object.keys(JSON.parse(tableColumnsJson.text())).map((key) => {
    return {data: key};
  });
}

$.extend(true, $.fn.dataTable.defaults, {
  columns: tableColumns,
  dom:
      "<'mt-3 mb-4'" +
      "<'row g-0'<'col-sm-6 d-flex align-items-center mb-2 mb-sm-0'li><'col-sm-6 d-flex justify-content-start justify-content-sm-end'p>>" +
      "tr" +
      "<'row g-0'<'col-sm-6 d-flex align-items-center mb-2 mb-sm-0'li><'col-sm-6 d-flex justify-content-start justify-content-sm-end'p>>>",
  deferRender: true,
  processing: true,
  retrieve: true,
  autoWidth: false,
  serverSide: true,
  pagingType: "numbers",
  language: dataTableLang,
  ajax: {
    type: "POST",
    data: function (d) {
      d.csrfmiddlewaretoken = document.querySelector(
          "input[name=csrfmiddlewaretoken]",
      ).value;
    },
  },
  lengthMenu: [
    [10, 25, 50, 100, 250],
    [10, 25, 50, 100, 250],
  ],
  pageLength: 25,
  searching: false,
  info: true,
  responsive: true,
  ordering: false,
});

//https://sweetalert2.github.io/
import Swal from "sweetalert2";

//https://github.com/js-cookie/js-cookie
import Cookies from "js-cookie";

//https://robinherbots.github.io/Inputmask/#/documentation
import Inputmask from "inputmask";

//https://clipboardjs.com/
import ClipboardJS from "clipboard";

export {DataTable, Cookies, Swal, Inputmask, ClipboardJS};

//https://select2.org/
window.select2 = require("select2");
require("select2/dist/js/i18n/az");
$.fn.select2.defaults.set("theme", "bootstrap-5");
$.fn.select2.defaults.set("language", "az");
$.fn.select2.defaults.set("placeholder", {
  id: "",
  text: "Birini seçin",
});
$.fn.select2.defaults.set("allowClear", true);
